import { Route, Switch } from "react-router-dom";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import MainLayout from "src/layout/main-layout";
import ToastifyScreen from "src/libraries/components/toastify/toastify.screen";
import { ENUM_PAGE } from "./libraries/enums/pages";
import { LoginScreen } from "./pages/login/login-screen";
import { RegisterScreen } from "./pages/register/register-screen";
import PrivateRoute from "./common/routes/private-route";
function App() {
  return (
    <>
      <Switch>
        <Route path={ENUM_PAGE.LOGIN} component={LoginScreen} />
        <Route path={ENUM_PAGE.REGISTER} component={RegisterScreen} />
        <PrivateRoute path="*" component={MainLayout} />
        {/* <Route path="*" component={MainLayout} /> */}
      </Switch>

      <ToastifyScreen></ToastifyScreen>
    </>
  );
}

export default App;
